import { __rest } from "tslib";
import React from 'react';
import cn from 'classnames';
import MetaText from "../../ui/Typography/texts/MetaText";
import styles from './ScreenReaderOnlyText.module.scss';
const ScreenReaderOnlyText = (_a) => {
    var { children, Tag = 'span', foldOutOnFocus = false, className } = _a, props = __rest(_a, ["children", "Tag", "foldOutOnFocus", "className"]);
    return (React.createElement(MetaText, Object.assign({ Tag: Tag, className: cn(styles.container, foldOutOnFocus && styles.foldOutOnFocus, className) }, props), children));
};
export default ScreenReaderOnlyText;
//# sourceMappingURL=ScreenReaderOnlyText.js.map